import InstallWebPackageManagers from "../../../../contents/docs/integrate/_snippets/install-web-package-managers.mdx";
import Tab from "components/Tab";
import AppRouterSetup from "../../../../contents/docs/integrate/_snippets/nextjs/app-router-setup.mdx";
import PagesRouterSetup from "../../../../contents/docs/integrate/_snippets/nextjs/pages-router-setup.mdx";
import * as React from 'react';
export default {
  InstallWebPackageManagers,
  Tab,
  AppRouterSetup,
  PagesRouterSetup,
  React
};